// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UploadDialog_wrap_1xhEc","text":"UploadDialog_text_2Pf2B","button":"UploadDialog_button_3Bbmc","edit":"UploadDialog_edit_1tabG"};